import { memo, ReactNode } from "react";

interface DeferredRenderProps {
  children: ReactNode;
  idleTimeout?: number;
}

export const DeferredRender = memo(
  ({
    children,
    //, idleTimeout
  }: DeferredRenderProps) => {
    return <>{children}</>;

    // const [render, setRender] = useState<boolean>(false);
    // const deferedRender = useDeferredValue(render);
    // const [timeoutComplete, setTimeoutComplete] = useState<boolean>(false);

    // useTimeout(
    //   () => {
    //     setTimeoutComplete(true);
    //   },
    //   idleTimeout || 1,
    //   {
    //     autoInvoke: true,
    //   },
    // );

    // useEffect(() => {
    //   setRender(true);
    // }, []);

    // if (!idleTimeout) return <>{children}</>;

    // if (!deferedRender || !timeoutComplete) return null;
    // return <>{children}</>;
  },
);
